export default "__VITE_ASSET__C2wuG00t__"